<div
  class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300"
>
  <div
    class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4"
  >
    <div>
      <h1
        class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight"
      >
        จัดการผู้ใช้
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        สร้างและดูแลบัญชีผู้ใช้งาน · ตั้งรหัสให้หรือให้ตั้งเอง · ดู log
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
      <button
        (click)="toggleDashboard()"
        class="w-full sm:w-auto px-4 py-3 bg-white/95 dark:bg-slate-900/95 text-slate-600 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all font-bold flex items-center justify-center gap-2"
      >
        <span class="material-icons text-[18px]">{{
          isDashboardOpen() ? "bar_chart" : "show_chart"
        }}</span>
        แดชบอร์ด
      </button>
      <button
        (click)="onRefresh()"
        class="w-full sm:w-auto p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all flex items-center justify-center"
      >
        <span class="material-icons">refresh</span>
      </button>
      <button
        *ngIf="canCreate"
        (click)="navigateToCreate()"
        class="w-full sm:w-auto px-5 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg shadow-amber-200/50 transition-all flex items-center justify-center gap-2 cursor-pointer"
      >
        <span class="material-icons text-[18px]">add</span>
        เพิ่มผู้ใช้
      </button>
    </div>
  </div>

  <div
    *ngIf="isDashboardOpen()"
    class="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8"
  >
    <div
      *ngFor="let stat of dashboardStats(); let i = index"
      class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-2xl p-6 shadow-2xl border border-slate-100/50 hover:-translate-y-1 transition-all relative overflow-hidden"
      [ngStyle]="{ 'animation-delay': i * 0.05 + 's' }"
    >
      <div
        class="w-12 h-12 p-2 rounded-xl flex items-center justify-center mb-4"
        [ngClass]="
          stat.color.replace('text-', 'bg-').replace('500', '50') +
          ' ' +
          stat.color
        "
      >
        <span class="material-icons text-2xl">{{ stat.icon }}</span>
      </div>
      <h4
        class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1"
      >
        {{ stat.title }}
      </h4>
      <div class="text-2xl font-black text-slate-800 dark:text-slate-100">
        {{ stat.value }}
      </div>
    </div>
  </div>

  <div
    class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden"
  >
    <div
      class="p-6 border-b border-slate-100/50 flex flex-col lg:flex-row lg:items-center justify-between gap-4"
    >
      <h3
        class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2"
      >
        <span class="material-icons text-amber-500">group</span>
        รายการผู้ใช้
      </h3>
      <div
        class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:max-w-xl"
      >
        <select
          [ngModel]="searchField()"
          (ngModelChange)="searchField.set($event)"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200"
        >
          <option *ngFor="let opt of searchFieldOptions" [value]="opt.value">
            {{ opt.label }}
          </option>
        </select>
        <div class="relative flex-1 flex">
          <span
            class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]"
            >search</span
          >
          <input
            type="text"
            placeholder="ค้นหา..."
            [ngModel]="searchText()"
            (ngModelChange)="searchText.set($event)"
            (keyup.enter)="onSearch()"
            class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none"
          />
        </div>
        <button
          (click)="onSearch()"
          class="px-4 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl transition-all"
        >
          ค้นหา
        </button>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <table
        class="w-full text-left border-collapse"
        [class.opacity-50]="isLoading()"
      >
        <thead
          class="sticky top-0 z-20 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50"
        >
          <tr
            class="text-xs font-bold text-slate-400 uppercase tracking-widest"
          >
            <th class="p-4 w-[90px]">ID</th>
            <th class="p-4">username / ชื่อ</th>
            <th class="p-4">สถานะ</th>
            <th class="p-4">รหัสผ่าน</th>
            <th class="p-4">ลาน</th>
            <th class="p-4">วันที่สร้าง</th>
            <th class="p-4 text-center w-[160px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
          <tr
            *ngFor="let u of users(); trackBy: trackById"
            class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all"
          >
            <td class="p-4 font-mono font-bold text-slate-500">{{ u.id }}</td>
            <td class="p-4">
              <span
                class="text-sm font-bold text-slate-700 dark:text-slate-200"
                >{{ u.displayName || "—" }}</span
              >
              <p class="text-xs text-slate-400 mt-0.5">{{ u.login }}</p>
            </td>
            <td class="p-4">
              <div class="flex flex-col gap-1">
                <span
                  class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold w-fit"
                  [ngClass]="
                    u.active
                      ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                      : 'bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-300'
                  "
                >
                  {{ u.active ? "Active" : "Inactive" }}
                </span>
                <span
                  class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold w-fit"
                  [ngClass]="cityLoginBadgeClass(u)"
                >
                  {{ cityLoginBadgeLabel(u) }}
                </span>
              </div>
            </td>
            <td class="p-4">
              <span
                class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                [ngClass]="passwordBadgeClass(u)"
              >
                {{ passwordBadgeLabel(u) }}
              </span>
            </td>
            <td class="p-4">
              <div class="flex flex-wrap gap-1.5 max-w-[280px]">
                <span
                  *ngFor="let s of u.sites"
                  class="inline-flex px-2 py-0.5 rounded-lg text-[11px] font-semibold bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300"
                >
                  {{ s.name }}
                </span>
                <span
                  *ngIf="u.siteTotalCount > u.sites.length"
                  class="inline-flex px-2 py-0.5 rounded-lg text-[11px] font-bold text-slate-500 bg-slate-100 dark:bg-slate-800"
                >
                  +{{ u.siteTotalCount - u.sites.length }}
                </span>
                <span
                  *ngIf="u.siteTotalCount === 0"
                  class="text-xs text-slate-400"
                  >—</span
                >
              </div>
            </td>
            <td class="p-4 text-slate-400 text-xs whitespace-nowrap">
              {{ u.createDate | date: "dd/MM/yyyy HH:mm" }}
            </td>
            <td class="p-4 text-center">
              <div class="inline-flex items-center gap-1.5">
                <button
                  type="button"
                  (click)="openSessions(u)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-violet-400 text-slate-400 hover:text-violet-500 transition-all cursor-pointer"
                  title="Session / เตะเครื่อง"
                >
                  <span class="material-icons text-base">devices</span>
                </button>
                <button
                  type="button"
                  (click)="openLogs(u)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-sky-400 text-slate-400 hover:text-sky-500 transition-all cursor-pointer"
                  title="ดู Log"
                >
                  <span class="material-icons text-base">history</span>
                </button>
                <button
                  *ngIf="canUpdate"
                  (click)="navigateToEdit(u)"
                  class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all cursor-pointer"
                  title="แก้ไข"
                >
                  <span class="material-icons text-base">edit</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="users().length === 0 && !isLoading()">
            <td colspan="7" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">search_off</span>
              <p class="font-bold">ไม่พบข้อมูลผู้ใช้</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="px-6 py-4 border-t border-slate-100/50 flex flex-col md:flex-row items-center justify-between gap-4"
    >
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span
          >แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก
          {{ totalItems() | number }} รายการ</span
        >
        <select
          (change)="onPageSizeChange($event)"
          [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 text-sm rounded-lg font-bold px-2 py-1 outline-none"
        >
          <option *ngFor="let size of pageSizeOptions" [value]="size">
            {{ size }} / หน้า
          </option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button
          (click)="setPage(currentPage() - 1)"
          [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30"
        >
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button
          *ngFor="let page of pagesArray"
          (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold"
          [ngClass]="
            page === currentPage()
              ? 'bg-amber-400 text-white'
              : 'text-slate-600 hover:bg-amber-50'
          "
        >
          {{ page }}
        </button>
        <button
          (click)="setPage(currentPage() + 1)"
          [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30"
        >
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>

  <app-modal-manage-user
    *ngIf="isModalOpen()"
    [data]="selectedUser()"
    (close)="closeModal()"
    (saveSuccess)="onRefresh()"
  >
  </app-modal-manage-user>

  <app-modal-user-login-logs
    *ngIf="isLogsOpen() && logsUser() as logUser"
    [user]="logUser"
    (close)="closeLogs()"
  >
  </app-modal-user-login-logs>

  <app-modal-user-sessions
    *ngIf="isSessionsOpen() && sessionsUser() as sessionUser"
    [user]="sessionUser"
    (close)="closeSessions()"
  >
  </app-modal-user-sessions>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
